import { MAIN_API_ROOT } from 'app_config';

import createApiClient from './createApiClient';

export const apiClient = createApiClient(MAIN_API_ROOT);
